jQuery(function ($) {
/***| Document Ready Start |***/
    $(document).ready(function() { 
        TestimonialSlider();
        li_has_submenu();
        counterScroll();
        mobileMenu();
        homeBnrSlider();
        servicetabpanel();
        ftergallerySlider();
        faqacc();
        footerAcco();
        recentprojectSlider();
        searchClose();
        cstScroll();
        videomodal();
        productsTab();
        industrypartner();
        mega_submenu();
        $('.menuIcon').click(function() {
            $('.menu-main').toggleClass('openMenu');
            $('.menuIcon, .menuClose').toggleClass('menuCloseActive');
            $('body').toggleClass('fixbody');
        });

        $(".overlay, .menuClose").click(function() {
            closeMenu();
        });
    });
/***| Document Ready End |***/

/****| Window Load Start |****/
$(window).on('load', function() {
     hStickyPadd();
     counterScroll();
});
/****| Window Load End |***/


/****| Window Resize Start |***/
$(window).resize(function() { 
	closeMenu();
	setTimeout(function() {
        mobileMenu();
        hStickyPadd();
    }, 360);
});
/****| Window Resize End |***/

/****| Window Scroll Start |***/
$(window).scroll(function() {
    cstScroll();
	setTimeout(function() {
        li_has_submenu();
        hStickyPadd();
    }, 350);
});
/****| Window Scroll End |****/


    function closeMenu() {
        $('.menu-main').removeClass('openMenu');
        $('.menuIcon, .menuClose').removeClass('menuCloseActive');
        $('body').removeClass('fixbody');
    }
    function homeBnrSlider() {
        if (jQuery('.homeBnrSlider').length > 0) {
            jQuery('.homeBnrSlider').slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 3500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay:true,
                autoplaySpeed:3500,
                cssEase: 'linear',
                responsive: [{
                    breakpoint: 767,
                    settings: {
                        arrows: false,
                        dots: true,
                    }
                }]
            });
        }
    }
    function TestimonialSlider() {
        if (jQuery('.TestimonialSlider').length > 0) {
            jQuery('.TestimonialSlider').slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 2000,
                appendArrows: '.testimniClint-arrow',
                autoplaySpeed: 0,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: false,
                cssEase: 'linear',
                responsive: [{
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                }, {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }]
            });
        }
    }

    function industrypartner() {
         if (jQuery('.industrypartnrSlider').length > 0) {
            $('.industrypartnrSlider').slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                autoplay: true,
                speed: 5200,
                autoplaySpeed: 0,
                cssEase: 'linear',
                infinite: true,
                arrows: false,
                dots: false,
                pauseOnHover: false,
                responsive: [{
                    breakpoint: 1480,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                    }
                }, {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                }]
            });
        }
    }

    function recentprojectSlider() {
        if (jQuery('.recentprojectSlider').length > 0) {
            jQuery('.recentprojectSlider').slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 1500,
                appendArrows: '.recentproject-arrow',
                autoplaySpeed: 0,
                slidesToShow: 4,
                slidesToScroll: 1,
                autoplay: false,
                cssEase: 'linear',
                responsive: [{
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                }, {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }]
            });
        }
    }
    function ftergallerySlider() {
        if (jQuery('.ftergallerySlider').length > 0) {
              new Swiper('.swiper', {
              loop: true,
              spaceBetween: 20,
              centeredSlides: true,
              speed: 1500,
              breakpoints: {
                0: { slidesPerView: 2, spaceBetween: 10 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 }
              }
            });
        }
    }
    // function li_has_submenu() {
    //     $('ul.eCommerceUl li:has(ul)').addClass('li_has_submenu');
    //     $('.cstMenuDrpArrow').remove();

    //     if ($('.eCommerceUl > li').children("ul").length > 0) {
    //         $(".eCommerceUl > li > ul").parent('li').append("<span class='cstMenuDrpArrow'></span>");
    //         if ($(window).width() <= 991) {
    //             $(".cstMenuDrpArrow").off('click').on('click', function(event) {
    //                 event.stopPropagation();
    //                 if ($(this).parent().hasClass("openSubmenu")) {
    //                     $(this).parent().removeClass("openSubmenu");
    //                     $(this).siblings('.sub-menu').slideUp();
    //                 } else {
    //                     $(".cstMenuDrpArrow").parent().removeClass("openSubmenu");
    //                     $('.cstMenuDrpArrow').siblings('.sub-menu').slideUp();
    //                     $(this).parent().addClass("openSubmenu");
    //                     $(this).siblings('.sub-menu').slideDown();
    //                 }
    //             });
    //         } else {
    //             $(".cstMenuDrpArrow").on('click', function(event) {
    //                 event.stopPropagation();
    //                 if ($(this).parent().hasClass("openSubmenu")) {
    //                     $(this).parent().removeClass("openSubmenu");
    //                 } else {
    //                     $(".cstMenuDrpArrow").parent().removeClass("openSubmenu");
    //                     $(this).parent().addClass("openSubmenu");
    //                 }
    //             });
    //         }
    //     }
    // }
    function li_has_submenu() {

    // ul OR megamenu-div dono detect kare
    $('ul.eCommerceUl li').has('ul, .megamenu-div').addClass('li_has_submenu');

    $('.cstMenuDrpArrow').remove();

    // arrow add for ul OR megamenu-div
    $(".eCommerceUl > li").has("ul, .megamenu-div")
        .append("<span class='cstMenuDrpArrow'></span>");

    if ($(window).width() <= 991) {

        $(".cstMenuDrpArrow").off('click').on('click', function(event) {
            event.stopPropagation();

            let parent = $(this).parent();
            let submenu = parent.children('ul, .megamenu-div');

            if (parent.hasClass("openSubmenu")) {
                parent.removeClass("openSubmenu");
                submenu.slideUp();
            } else {
                $(".cstMenuDrpArrow").parent().removeClass("openSubmenu");
                $('.eCommerceUl > li').children('ul, .megamenu-div').slideUp();

                parent.addClass("openSubmenu");
                submenu.slideDown();
            }
        });

    } else {

        $(".cstMenuDrpArrow").off('click').on('click', function(event) {
            event.stopPropagation();

            let parent = $(this).parent();

            $(".cstMenuDrpArrow").parent().removeClass("openSubmenu");
            parent.toggleClass("openSubmenu");
        });

    }
}
    function mobileMenu() {
    	if ($(window).width() <= 991) { 
    		 $(".header-bt .eCommercCnt > .eCommerce-menu").appendTo(".menu-main");
             $(".headermdCnt > .inforDtail").appendTo(".menu-main");
             $(".eCommercCnt > .eCommerIcnlst").appendTo(".headermdCnt");
             $(".menuIcon").appendTo(".eCommerIcnlst");
          } else {
            $(".menu-main > .eCommerce-menu").appendTo(".header-bt .eCommercCnt");
            $(".menu-main > .inforDtail").appendTo(".headermdCnt");
            $(".headermdCnt > .eCommerIcnlst").appendTo(".eCommercCnt");
            $(".eCommerIcnlst > .menuIcon").appendTo(".header-bt");
    	}
    }
    function counterScroll() {
        const counters = document.querySelectorAll('.counter');
    	counters.forEach(counter => {
    	  counter.innerText = '0';

    	  const updateCounter = () => {
    	    const target = +counter.getAttribute('data-target');
    	    const current = +counter.innerText;

    	    const increment = target / 100;

    	    if (current < target) {
    	      counter.innerText = Math.ceil(current + increment);
    	      setTimeout(updateCounter, 30);
    	    } else {
    	      counter.innerText = target;
    	    }
    	  };

    	  updateCounter();
    	});
    }
   function servicetabpanel() {
	 const vtabBtns = document.querySelectorAll(".tab-lst");
	 const vtabPanels = document.querySelectorAll(".servic-Panel");

	 vtabBtns.forEach(btn => {
	    btn.addEventListener("click", () => {
	      vtabBtns.forEach(b => b.classList.remove("active"));
	      vtabPanels.forEach(p => p.classList.remove("active"));

	      btn.classList.add("active");
	      document.getElementById(btn.dataset.tab).classList.add("active");
	    });
	  });
   }
    function faqacc() {
        if (jQuery('.faq-question').length > 0) {
            $('.faq-question').click(function(){
                let parent = $(this).parent();
                if(parent.hasClass('active')){
                parent.removeClass('active');
                parent.find('.faq-answer').slideUp(500);
                } else {
                $('.faq-item').removeClass('active');
                $('.faq-answer').slideUp(500);
                parent.addClass('active');
                parent.find('.faq-answer').slideDown(500);
                }
            });
       }
    }
    /* ------| Footer Accordian |--------- */
    function footerAcco() {
        $('.footer-acco-title').click(function() {
            var header_height = $('.header').outerHeight();
            if ($(this).hasClass('footerMinus')) {
                $(this).next().slideUp();
                $(this).removeClass('footerMinus');
            } else {
                $('.footer-acco-title').removeClass('footerMinus');
                $(this).addClass('footerMinus');
                $('.ftr-bdyCnt').slideUp();
                $(this).next().slideDown();
            }
        });
    }

    /* ------| Find Sub Menu and Sub menu Click |--------- */
    function mega_submenu() {
        $('.has_grandchildren > li.grandchildren')
        .off('click')
        .on('click', function () {
            if ($(window).width() <= 991) {
                const submenu = $(this).children('ul');
                // Close others
                $('.has_grandchildren > li.grandchildren ul')
                .not(submenu)
                .slideUp();
                // Toggle current
                submenu.stop(true, true).slideToggle();
            }
        });
    }

    // function mega_submenu() {
    //     $('.has_grandchildren > li.grandchildren')
    //         .off('click')
    //         .on('click', function (e) {
    //         if ($(window).width() <= 991) {
    //             e.stopPropagation();
    //             const parent = $(this);
    //             const submenu = parent.children('ul');
    //             // Toggle current
    //             if (parent.hasClass('accoMinus')) {
    //             parent.removeClass('accoMinus');
    //             submenu.slideUp();
    //             } else {
    //             // Close all others
    //             $('.has_grandchildren > li.grandchildren')
    //                 .removeClass('accoMinus')
    //                 .children('ul').slideUp();

    //             // Open current
    //             parent.addClass('accoMinus');
    //             submenu.slideDown();
    //             }
    //         }
    //     });
    // }
});
/* ------| Header Sticky Padding |--------- */
function hStickyPadd() {
    var hHeight = $('header.header').outerHeight() || 0;
    $('.headerPadd').height(hHeight);
}
function cstScroll() {
    if ($(this).scrollTop() > 40) {
        $('.sticky-header').addClass('header_scroll')
    } else {
        $('.sticky-header').removeClass('header_scroll');
    }
}
// Search close button Script
function searchClose(){
    document.addEventListener('click', function (e) {
    if (e.target.closest('.search-modal__close-button')) {
        console.log('Close button clicked');
        const modal = e.target.closest('details');
        if (modal) {
        modal.removeAttribute('open');
        }
    }
    });
}


function videomodal() {
    $(document).on('click','.play-btn',function(){
    let id = $(this).data('id');
    $('#video-popup-overlay,#video-popup-container').fadeIn();
        $('#video-popup-iframe').attr(
            'src',
            'https://www.youtube.com/embed/'+id+'?autoplay=1&rel=0'
        );
    });
    $(document).on('click','#video-popup-close,#video-popup-overlay',function(){
        $('#video-popup-overlay,#video-popup-container').fadeOut();
        $('#video-popup-iframe').attr('src','');
    });
}

// product collection hide and show tab section
function productsTab(){
  const initTabs = () => {
    const tabs = document.querySelectorAll('.tab-lst');
    const sections = document.querySelectorAll('.featured-tab-content');
    if(!tabs.length || !sections.length) return;
    function activateTab(tabName){
      sections.forEach(section=>{
        section.style.display =
          section.dataset.tab === tabName ? 'block' : 'none';
      });
      tabs.forEach(tab=>{
        tab.classList.toggle(
          'active',
          tab.dataset.tab === tabName
        );
      });
    }
    tabs.forEach(tab=>{
      tab.addEventListener('click',()=>{
        activateTab(tab.dataset.tab);
      });
    });
    activateTab(tabs[0].dataset.tab);
  };
  initTabs();
  document.addEventListener("shopify:section:load", initTabs);
}


